<style lang="scss"></style>

<template>
  <div id="modal-remove-vendedor" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">ATENÇÃO!</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-block shadow0 m0 pb0">
                <div class="title-block" v-if="vendedor">
                  <h3 class="title adasd">
                    Tem certeza que deseja remover o vendedor:
                    <span
                      class="text-info"
                    >{{ vendedor.nome }}</span> ?
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="remover"
            :disabled="enviando"
          >{{ enviando ? "REMOVENDO..." : "SIM" }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">NÃO</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, closeLoading } from '../../helpers';
import VendedorService from '../../services/VendedorService';

export default {
  name: 'modal-remove-vendedor',
  data() {
    return {
      enviando: false,
      vendedor: null,
    };
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-remove-vendedor').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.removeVendedorId = null;
    });

    if (this.$parent.removeVendedorId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.vendedor = null;
    },
    async load() {
      try {
        showLoading();

        if (this.$parent.removeVendedorId === 0) return;

        this.vendedor = await VendedorService.findById(
          this.$parent.removeVendedorId,
        );
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-remove-vendedor').modal('show');
      }
    },
    async remover() {
      try {
        this.enviando = true;

        showLoading();

        await VendedorService.remove(this.vendedor.id);

        this.$toast.success('Vendedor removido com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-remove-vendedor').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
